import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Supabase query safety utilities
export const safeSupabaseQuery = {
  // Ensure all queries have proper from clause
  from: (tableName: string) => {
    if (!tableName || typeof tableName !== 'string') {
      throw new Error(`Invalid table name: ${tableName}`);
    }
    return tableName;
  },
  
  // Validate query parameters
  validateParams: (params: any) => {
    if (params === null || params === undefined) {
      return {};
    }
    return params;
  },
  
  // Safe error handling for Supabase responses
  handleResponse: <T>(response: { data: T | null; error: any }) => {
    if (response.error) {
      console.error('Supabase query error:', response.error);
      throw new Error(`Database query failed: ${response.error.message || 'Unknown error'}`);
    }
    return response.data;
  }
};

/**
 * Wraps a promise with a timeout to prevent long-running operations from blocking
 * critical user flows like redirects and authentication
 */
export function withTimeout<T>(p: Promise<T>, ms = 8000): Promise<T> {
  return Promise.race([
    p,
    new Promise<T>((_, rej) => setTimeout(() => rej(new Error('timeout')), ms)),
  ]);
}
